import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextM } from '../../../../../infra/dls/components/typography';
import { Modal } from '../../../../../infra/dls/components/modal/modal';
import { Button } from '../../../../../infra/dls/components/button/button';
import { t } from '../../../../../infra/i18n';
export var LockedAccountModal = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    return (_jsxs(Modal, { open: open, onClose: onClose, title: t('auth:two_fa.locked_modal_title'), children: [_jsx(Modal.Content, { children: _jsx(TextM, { color: "primary", children: t('auth:two_fa.locked_modal_content') }) }), _jsx(Modal.Actions, { children: _jsx(Button.Primary, { type: "button", onClick: onClose, children: t('auth:two_fa.return_to_login') }) })] }));
};
